import Vue from 'vue';
export default Vue.component('ed-badge', { name: 'ed-badge'});